export default __webpack_public_path__ + "static/media/investment.8bd92f98.svg";